import React, { useCallback, useMemo } from 'react';
import styles from './SavedFilter.module.scss';
import Card from '../../../components/Card/Card';
import useSavedFiltersQuery from '../../../queries/useSavedFiltersQuery';
import { Icon, Modal, Spin, Tag } from 'antd';
import { shortFilterName } from '../../../../../helpers/filterName';
import { useDispatch, useSelector } from 'react-redux';
import { chosenFilterIdSelector } from '../../../store/selectors/new-document.selector';
import setDocumentDefaultFilter from '../../../requests/setDocumentDefaultFilter';
import { chooseDocumentFilterNew } from '../../../store/actions/documentFilterNew.actions';
import useDeleteDocumentsFilter from '../../../mutation/useDeleteDocumentsFilter';
import { actions } from '../../../store/actions/new-document.actions';

const { confirm } = Modal;

const SavedFilter = () => {
  const { data: filters = [], isFetching } = useSavedFiltersQuery({
    staleTime: Infinity,
  });
  const { isDeleteDocumentsFilterLoading, onDeleteDocumentsFilter } =
    useDeleteDocumentsFilter();

  const chosenFilterId = useSelector(chosenFilterIdSelector);

  const dispatch = useDispatch();

  const clickChooseFilter = useCallback((id) => {
    setDocumentDefaultFilter(id);
    dispatch(chooseDocumentFilterNew(id));
  }, []);

  const confirmDeleteFilter = useCallback((e, id) => {
    e.preventDefault();
    confirm({
      title: 'Вы действительно хотите удалить этот фильтр?',
      async onOk() {
        await onDeleteDocumentsFilter(id);
        dispatch(actions.setChosenDocumentsFilter({ id: null, name: null }));
      },
      onCancel() {},
    });
  }, []);

  const savedFiltersList = useMemo(() => {
    return filters.map((filter) => (
      <Tag
        color={chosenFilterId === filter.id ? '#0995ED' : '#E9E9E9'}
        className={styles.tag}
        onClick={() => clickChooseFilter(filter.id)}
        key={filter.id}
        closable
        onClose={(e) => confirmDeleteFilter(e, filter.id)}
      >
        <span
          style={{ color: chosenFilterId === filter.id ? 'white' : 'black' }}
          className={styles.textTag}
        >
          {isDeleteDocumentsFilterLoading ? (
            <Icon type="loading" />
          ) : (
            shortFilterName(filter.name)
          )}
        </span>
      </Tag>
    ));
  }, [filters, chosenFilterId, clickChooseFilter]);

  return (
    <Card heading="Сохраненные фильтры">
      <Spin
        size="small"
        spinning={isFetching}
      >
        <div className={styles.savedFiltersTags}>
          {savedFiltersList.length ? (
            savedFiltersList
          ) : (
            <div className={styles.text}>
              <div style={{ fontWeight: 500 }}>
                Вы еще не добавили ни одного набора фильтров
              </div>
              <div>Нажмите “Сохранить фильтр”, чтобы создать собственный</div>
            </div>
          )}
        </div>
      </Spin>
    </Card>
  );
};

export default SavedFilter;
